import 'src/polyfills/object-groupby'

import React, { useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBank } from '@fortawesome/free-solid-svg-icons'

import RadioList from 'src/components/RadioList'
import { capitalize } from 'src/utils/inflections'

const BankList = ({ i18n, bank }) => {
  const [ singleAccount, groupedAccounts ] = useMemo(() => [
    bank.accounts.length == 1,
    Object.groupBy(bank.accounts, account => account.institution_name)
  ], [ bank.accounts ])

  const noEligibleAccounts = bank.accounts.length > 0 && bank.eligibleAccounts.length === 0

  return (
    <fieldset>
      <legend className="form-label float-none fs-6 d-flex align-items-end justify-content-between gap-4">
        {/* {i18n.t('payment_methods.bank')}*/}Bank account
        <button
          type="button"
          className="btn btn-sm btn-link ms-auto p-0 align-baseline"
          onClick={bank.openPicker}
        >
          {/* {i18n.t('change')}*/}Connect a different bank
        </button>
      </legend>

      {noEligibleAccounts &&
        <div className="alert alert-warning">
          {singleAccount
            ? "The connected account doesn't support bank transfers."
            : "None of the connected accounts support bank transfers."
          } Please connect a different account.
        </div>
      }

      {Object.entries(groupedAccounts).map(([ institutionName, accounts ]) => (
        <RadioList
          key={institutionName}
          id="bank_account"
          name="bank_account"
          wrapperClass="card mb-3"
          legendClass="card-header fs-6"
          optionsClass="list-group list-group-flush"
          optionClass="list-group-item"
          inputClass={singleAccount ? 'visually-hidden' : "form-check-input me-2"}
          labelClass="form-check-label stretched-link"
          legend={<>
            <FontAwesomeIcon icon={faBank} className="me-2" />
            {institutionName}
          </>}
          options={accounts.map(account => {
            const eligible = account.supported_payment_method_types?.includes('us_bank_account')
            const basic = `${capitalize(account.subcategory)} ••••${account.last4}`
            const display = account.display_name || basic
            return {
              value: account.id,
              disabled: !eligible,
              hint: !eligible && "This account doesn't support bank transfers",
              label: <>
                <b>{display}</b>
                {
                  account.display_name &&
                  <div className="form-text mt-0">{basic}</div>
                }
              </>
            }
          })}
          value={bank.accountId}
          onChange={e => bank.setAccountId(e.target.value)}
        />
      ))}
    </fieldset>
  )
}

export default BankList
